import CustomDataGrid from "../../../components/Shared/Table/CustomDataGrid";
import { IDusNodeDataGridRow, IFullDeviceDetails, IRadioNodesDataGridRow } from "../../../store/api/deviceConfig/types";
import { GridEventListener } from "@mui/x-data-grid";
import { GridRowParams } from "@mui/x-data-grid";
import { setOpenDuDrawer, setSelectedDuNode } from "../../../store/api/devices/reducers";
import { GridRowSelectionModel } from "@mui/x-data-grid";
import { useDusNodesData } from "./hooks";
import { useStoreDispatch } from "../../../store/hooks";
import { prepareDuNodeDataGrid } from "../helpers";
import { useSelector } from "react-redux";
import { isOpenDuDrawerSelector, selectedDeviceSelector } from "../../../store/api/devices/selectors";
import DUDrawer from "./DUDrawer";
import { prepareActionProps } from "../../../components/Actions/ActionHelper";
import { useEffect, useState } from "react";
import { duOptions } from "../../../components/Actions/ActionOptions";
import Actions from "../../../components/Actions/Actions";
import { statusRadioNodes } from "../../../globals/globals";

const DistributedUnit = () => {
  const dispatch = useStoreDispatch();
  const isOpenDuDrawer = useSelector(isOpenDuDrawerSelector);

  const {
    data,
    isLoading,
    permissions,
    radioNodesColumns,
    rowClicked,
    setRowClicked,
    selectedRowData,
    setSelectedRowData,
    setDataForPartialRefresh,
  } = useDusNodesData();

  const getDataFromApi = data?.data || [];
  const rowsData = prepareDuNodeDataGrid(getDataFromApi) || [];
  const noOfRows = data?.totalItems || 0;

  let partialRefreshRequiredDUs: Array<IDusNodeDataGridRow> = [];

  // Filter rowsData to get candidaties for partial refresh
  if (rowsData && rowsData.length > 0) {
    partialRefreshRequiredDUs = rowsData.filter((item) => item.model === "" && statusRadioNodes.some((status) => status === item.status));
  }

  useEffect(() => {
    if (partialRefreshRequiredDUs.length > 0) {
      const partialRefInterval = setInterval(() => {
        setDataForPartialRefresh(partialRefreshRequiredDUs);
      }, 2000);

      return () => clearInterval(partialRefInterval);
    } else setDataForPartialRefresh([]);
    // Dependency purposefully excluded to avoid endless loop condition: partialRefreshRequiredDUs and setDataForPartialRefresh
  }, [rowsData]);

  const [NoOfSelectedRow, setNoOfSelectedRow] = useState(0);
  const [selectedRow, setSelectedRow] = useState<IDusNodeDataGridRow>();
  const selectedDevice: IFullDeviceDetails = useSelector(selectedDeviceSelector);
  const actionProps = prepareActionProps(selectedDevice?.objectKey!, selectedDevice.name, selectedRow, duOptions, "Dus", false, null);

  const handleRowClicked: GridEventListener<"rowClick"> = (params: GridRowParams<IDusNodeDataGridRow>) => {
    if (!permissions?.hasOpCodeGroup("view_topology")) return;
    setRowClicked(true);
    dispatch(setOpenDuDrawer(true));
    setSelectedRowData(params.row);
    dispatch(setSelectedDuNode(params.row));
  };
  const handleOnRowSelected = (rowIds: GridRowSelectionModel) => {
    const rowIdLength = rowIds?.length;
    setNoOfSelectedRow(rowIdLength);
    if (rowIdLength === 1) {
      setSelectedRow(() => rowsData.filter((item) => item.id === rowIds[0])[0]);
    }
  };

  const handleCloseButtonClicked = (value: boolean) => {
    setRowClicked(value);
  };

  return (
    <>
      {rowClicked && isOpenDuDrawer && <DUDrawer data={selectedRowData} closedButtonClicked={handleCloseButtonClicked} rowsData={rowsData} />}
      <div
        style={{
          minHeight: "300px",
          border: "1px solid var(--color-border)",
          borderRadius: "var(--radius)",
          padding: "18px",
          boxShadow: "var(--shadow-card)",
          backgroundColor: "var(--card)",
        }}
      >
        {NoOfSelectedRow > 0 ? (
          <div className="pb-4">
            <div className="flex gap-2 items-center">
              <p className="text-sm text-muted-foreground pr-2">
                {NoOfSelectedRow} selected
              </p>
              {permissions?.hasOpCodeGroup("manage_topology") && NoOfSelectedRow === 1 && !!actionProps && <Actions actionProps={actionProps} tableId="dus" />}
            </div>
          </div>
        ) : (
          <></>
        )}
        <div>
          <p className="text-sm text-muted-foreground pb-2">{`Showing ${rowsData?.length || 0} results`}</p>
          {isLoading && <p>Loading...</p>}
          {!isLoading && (
            <CustomDataGrid
              tableId="dus"
              rows={rowsData}
              columns={radioNodesColumns}
              checkboxSelection={true}
              rowCount={noOfRows}
              loading={isLoading}
              disableColumnMenu={true}
              disableRowSelectionOnClick={true}
              onRowSelectionModelChange={handleOnRowSelected}
              getRowId={(row: IRadioNodesDataGridRow) => row.id}
              onRowClick={handleRowClicked}
              sx={{
                "& .MuiDataGrid-virtualScroller": { overflowY: "hidden" },
                "& .MuiDataGrid-scrollbar--vertical": { display: "none" },
              }}
              fillContainer={false}
            />
          )}
        </div>
      </div>
    </>
  );
};

export default DistributedUnit;
